import { Link } from 'react-router-dom'

interface PageHeaderProps {
  eyebrow?: string
  title: string
  description?: string
  action?: {
    label: string
    to?: string
    onClick?: () => void
    icon?: string
  }
}

export default function PageHeader({ eyebrow = 'Workspace', title, description, action }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {description && <p className="page-description">{description}</p>}
        <nav aria-label="Breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            <li className="breadcrumb-item active" aria-current="page">{title}</li>
          </ol>
        </nav>
      </div>
      {action && (action.to ? (
        <Link to={action.to} className="btn btn-primary page-action">
          <i className={`bi ${action.icon ?? 'bi-plus-lg'}`} aria-hidden="true" />{action.label}
        </Link>
      ) : (
        <button className="btn btn-primary page-action" type="button" onClick={action.onClick}>
          <i className={`bi ${action.icon ?? 'bi-plus-lg'}`} aria-hidden="true" />{action.label}
        </button>
      ))}
    </header>
  )
}
